import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	closeButton: {
		id: 'workflow-view-diagram-modal.close-button',
		defaultMessage: 'Close',
		description: 'Label for the button to close the workflow view diagram modal',
	},

	errorMessage: {
		defaultMessage: 'We couldn’t load the workflow.',
		id: 'workflow-view-diagram-modal.error-message',
		description: 'Error message for when the modal fails to load its content',
	},

	noPermissionToViewThisWorkflow: {
		defaultMessage: 'You do not have permission to view this workflow.',
		id: 'workflow-view-diagram-modal.no-permission-to-view-this-workflow',
		description: 'Error message for when a user does not have permission to view a workflow',
	},
});
